import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CompareBar } from '@hpi-sox/hpstellar-core';

import WithCompare from '../compare-container';
import { withError } from '../../../shared/components/error-boundary';
import { getCompareBarGtmProps } from '../../../metrics/metrics-helpers';
import useProductPrice from '../../../hooks/useProductPrice';

import './compare-drawer.less';

const COMPARE_EXPANDED = 'compareExpanded';
function CompareDrawer(props) {
    const {
        compareProducts,
        toggleCompareProduct,
        clearCompareProducts,
        compareSlots,
        errors,
        headerComp,
        footer,
        closeMaxedError,
        history,
        match,
        expanded,
        setCompareExpanded,
    } = props;

    const { error, maxed } = errors;
    const full = compareProducts.length === compareSlots;
    const currentCompareProducts = error && full ? compareProducts.slice(0, 3) : [...compareProducts];
    const { prices } = useProductPrice(compareProducts);

    useEffect(() => {
        const compareClass = 'compareExpanded';
        if (expanded) {
            document.body.className += ` ${compareClass}`;
        } else {
            document.querySelector('body').classList.remove(compareClass);
        }

        const errorPad = maxed ? 60 : 0;
        const chatBtn = document?.getElementById('concierge');
        if (chatBtn) {
            chatBtn.style.setProperty('bottom', !expanded ? `${90 + errorPad}px` : `${220 + errorPad}px`, 'important');
        }
        const avatarBtn = document?.getElementsByClassName('chatbox-avatar-min')[0];
        if (avatarBtn) {
            avatarBtn.style.setProperty(
                'bottom',
                !expanded ? `${185 + errorPad}px` : `${275 + errorPad}px`,
                'important',
            );
        }

        return () => {
            if (chatBtn) {
                chatBtn.style.bottom = '50px';
            }
            if (avatarBtn) {
                avatarBtn.style.bottom = '185px';
            }
        };
    }, [expanded, maxed]);

    const shouldRender = compareProducts.length >= 0;
    const comparedProductSkus = [];
    const compareBarProducts =
        shouldRender &&
        currentCompareProducts &&
        currentCompareProducts
            .map(p => {
                comparedProductSkus.push(p.sku);
                // const { price: productPrice } = p || {};
                // const { tierMsg } = productPrice || {};
                // const price = productPrice ? { ...productPrice, ...(tierMsg ? { style: 'center' } : {}) } : {};

                const price = { ...(prices[p.sku] || {}), style: 'center' };
                // map StoreApp type product object
                if ((p._id || p.id) && p.name && p.imageUrl) {
                    return {
                        title: p.name,
                        image: { url: p?.imageUrl, alt: '' },
                        sku: p.sku,
                        price,
                    };
                }

                return {
                    title: p.title,
                    image: { url: p?.images && p?.images?.[0]?.src, alt: '' },
                    sku: p.sku,
                    price,
                };
            })
            .reverse();

    let gtmActions = shouldRender && getCompareBarGtmProps(comparedProductSkus);

    let warning = compareBarProducts.length === 1 && 'Please select at least two products to compare';

    return (
        <div className="compare-drawer" tabIndex={0}>
            {headerComp(compareProducts.length, !expanded)}
            {shouldRender && (
                <CompareBar
                    className="compare-bar"
                    expanded={expanded}
                    products={compareBarProducts}
                    maxCountToCompare={4}
                    onRemove={sku => {
                        toggleCompareProduct(compareProducts.filter(x => x.sku === sku)[0], true);
                    }}
                    onCompare={() => {
                        const { params } = match;
                        const { basename = '' } = params;
                        history.push(`${basename ? `/${basename}` : ''}/compare`);
                    }}
                    onClear={clearCompareProducts}
                    error={(error && 'Only products from the same category can be compared') || warning}
                    errorBarProps={{
                        isVisible: maxed,
                        title: 'You reached the maximum number of products to compare',
                        description: 'You can remove one of the products below and add a different one',
                        onClose: () => closeMaxedError(false),
                    }}
                    onToggle={setCompareExpanded}
                    gtmActions={gtmActions}
                />
            )}
            {footer}
        </div>
    );
}

CompareDrawer.defaultProps = {
    compareSlots: 4,
    headerComp: () => {},
};

CompareDrawer.propTypes = {
    compareSlots: PropTypes.number,
    compareProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
    toggleCompareProduct: PropTypes.func.isRequired,
    clearCompareProducts: PropTypes.func.isRequired,
    closeMaxedError: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setCompareExpanded: PropTypes.func.isRequired,
};

export default WithCompare(withRouter(withError(CompareDrawer)));
